import { FieldWrapper } from '@dixa/lib-shared-habla';
import {
  HookFormFieldWrappedBaseProps,
  useHookFormFieldWrapper,
} from 'lib-shared-hook-form';
import { useCallback, useState } from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';

import {
  PhoneNumberUserSelect,
  PhoneNumberUserSelectProps,
  PhoneNumberUserSelectValue,
} from 'components/phoneNumberUserSelect';

/**
 * Represents the React Hook Form variant of the {@link PhoneNumberUserSelect}
 * component.
 */
export const HookFormUserPhoneNumberSelect = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: HookFormFieldWrappedBaseProps<
    TFieldValues,
    TName,
    Partial<PhoneNumberUserSelectProps>
  >,
): JSX.Element => {
  const { controller, fieldWrapperProps } = useHookFormFieldWrapper(props);

  const [phoneNumber, setPhoneNumber] = useState<string | undefined>(
    props.componentProps?.phoneNumber,
  );

  const handleSelect = useCallback(
    (value: PhoneNumberUserSelectValue) => {
      setPhoneNumber(value.phoneNumber);
      controller.field.onChange(value);
      controller.field.onBlur();
    },
    [controller.field],
  );

  const handleToggle = useCallback(
    (isOpen) => {
      if (!isOpen) {
        controller.field.onBlur();
      }
    },
    [controller.field],
  );

  return (
    <FieldWrapper {...fieldWrapperProps}>
      <PhoneNumberUserSelect
        phoneNumber={phoneNumber}
        onSelect={handleSelect}
        onToggle={handleToggle}
        showRegionFlagPrefix={props.componentProps?.showRegionFlagPrefix}
        status={FieldWrapper.getStatus(fieldWrapperProps.meta)}
      />
    </FieldWrapper>
  );
};
